import React from 'react';
import '../styles/Votaciones.css';
import '../styles/Ediciones.css';
import Nav from 'react-bootstrap/Nav';
import { useState, useEffect } from 'react';

/* 
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
*/
const Votaciones = () => {
    const handleScroll = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [categorias, setCategorias] = useState([]);
    const [activeCategory, setActiveCategory] = useState('');

    useEffect(() => {
        const categoriasIniciales = [
            { id: 1, nombre: 'Artista o grupo musical' },
            { id: 2, nombre: 'Beauty, lifestyle y moda' },
            { id: 3, nombre: 'Creador de contenido' },
            { id: 4, nombre: 'Entretenimiento digital' },
            { id: 5, nombre: 'Emprendimiento' },
            { id: 6, nombre: 'Deportes' }
        ];
        setCategorias(categoriasIniciales);
        setActiveCategory(categoriasIniciales[0].id);
    }, []);

    /*     const [candidatos, setCandidatos] = useState([]);
        const [telefono] = useState('');
        const [setMessage] = useState(null);
        const [setMessageType] = useState(null); // 'error' o 'success'
    
    
        
    
        
    
        useEffect(() => {
            const fetchCandidatos = async () => {
                try {
                    const response = await axios.get('http://localhost:8000/candidatos/?estado=aceptado');
                    setCandidatos(response.data);
                } catch (error) {
                    console.error('Error al obtener los candidatos:', error);
                }
            };
            fetchCandidatos();
        }, []); */

    /*     const candidatosPorCategoria = candidatos.reduce((acc, candidato) => {
            const categoriaId = candidato.categoria.id || candidato.categoria;
            if (!acc[categoriaId]) {
                acc[categoriaId] = [];
            }
            acc[categoriaId].push(candidato);
            return acc;
        }, {}); */

    // Mostrar mensaje con animación
    /*     const showMessage = (text, type = 'error') => {
            setMessage(text);
            setMessageType(type);
            setTimeout(() => setMessage(null), 3000);
        }; */

    // Función para votar
    /*     const handleVote = async (candidatoTelefono, categoriaId) => {
            if (!telefono) {
                showMessage("Por favor, ingresa tu número de teléfono para votar.", 'error');
                return;
            }
    
            try {
                await axios.post('http://localhost:8000/api/votar/', {
                    telefono: telefono,
                    candidato_id: candidatoTelefono,
                    categoria_id: categoriaId
                });
                showMessage("¡Voto registrado con éxito!", 'success');
            } catch (error) {
                console.error("Error al registrar el voto:", error);
                showMessage(error.response?.data?.error || "Error al registrar el voto.", 'error');
            }
        }; */

    return (
        <div className="candidatos-container">
            {/*             <input
                type="text"
                placeholder="Tu número de teléfono"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                className="telefono-input"
            />
            {message && (
                <div className={`alert-message ${messageType === 'success' ? 'success' : ''}`}>
                    {message}
                </div>
            )} */}
            <Nav fill variant="tabs" activeKey={activeCategory} onSelect={(selectedKey) => setActiveCategory(selectedKey)}>
                {categorias.map(categoria => (
                    <Nav.Item key={categoria.id}>
                        <Nav.Link eventKey={categoria.id}>
                            {categoria.nombre}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>

            {/* 
            <div className="candidatos-grid">
                {candidatosPorCategoria[activeCategory] && candidatosPorCategoria[activeCategory].length > 0 ? (
                    candidatosPorCategoria[activeCategory].map(candidato => (
                        <Card className="candidato-card" key={candidato.telefono} style={{ width: '18rem', margin: '10px' }}>
                            {candidato.foto && (
                                <div>
                                    <Card.Img variant="top" src={`http://localhost:8000${candidato.foto}`} alt={candidato.nombre} className="candidato-foto" />
                                    <div className="vote-button-container">
                                        <button className="vote-button" onClick={() => handleVote(candidato.telefono, activeCategory)}>Votar</button>
                                    </div>
                                </div>
                            )}
                            <Card.Body>
                                <Card.Title className='candidato-nombre'>{candidato.nombre} {candidato.apellidos}</Card.Title>
                                <Card.Text className='candidato-descripcion'>{candidato.mensaje}</Card.Text>
                            </Card.Body>
                            <ListGroup className="list-group-flush">
                                <ListGroup.Item>
                                    <a className="link-candidato" href="/ruta-a-mas-info" target="_blank" rel="noopener noreferrer">
                                        ¿Quieres saber más sobre mi?
                                    </a>
                                </ListGroup.Item>
                            </ListGroup>
                        </Card>
                    ))
                ) : (
                    <div className="empty-category">
                        <p>No hay candidatos en esta categoría.</p>
                    </div>
                )}

            </div>
 */}
            <div className='tituloP'> ¡Próximamente! <br /> mientras tanto...</div>

            <button className="btn-scroll" onClick={() => handleScroll('candidatura-section')}>
                Enviar Candidatura
                <span className="arrow"></span>
            </button>
        </div>
    );
};

export default Votaciones;